module.exports = __webpack_public_path__ + "img/mercosul.4bd180af.png";